import React from 'react';
import { processSteps } from '../data/mock';

const Process = () => {
  return (
    <section className="py-24 lg:py-32 bg-[#F2F2F2] grid-bg">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-16">
          <span className="label-text text-[rgba(35,35,35,0.5)] mb-4 block">How I Work</span>
          <h2 className="section-title">My Process</h2>
        </div>

        {/* Process Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {processSteps.map((step, idx) => (
            <div
              key={idx}
              className="relative group"
            >
              <div className="card-sharp p-6 h-full">
                {/* Step Number */}
                <div className="font-mono text-5xl font-bold text-[rgba(35,35,35,0.1)] group-hover:text-[#38FF62] transition-colors duration-300 mb-4">
                  {step.step}
                </div>
                
                {/* Title */}
                <h3 className="font-display text-lg font-semibold mb-3">
                  {step.title}
                </h3>
                
                {/* Description */}
                <p className="font-body text-sm text-[rgba(35,35,35,0.7)]">
                  {step.description}
                </p>
              </div>

              {/* Connector Line (hidden on last item of each row) */}
              {idx < processSteps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-[rgba(35,35,35,0.2)]" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;